import { Routes } from '@angular/router';
import { OnlyLoggedUsersGuard } from './core/security/guards/only-logged-users.guard';
import { ValidateSyncGuard } from './core/security/guards/validate-sync.guard';

export const routes: Routes = [
    // Main redirect
    { path: '', redirectTo: 'home', pathMatch: 'full', data: { reuse: true } },

    // Views with no wrapping layout
    {
        path: 'login',
        loadComponent: () =>
            import('./views/security/login/login.component').then(
                m => m.LoginComponent
            )
    },
    {
        path: 'data-sync',
        loadComponent: () =>
            import('./views/security/data-sync/data-sync.component').then(
                m => m.DataSyncComponent
            ),
        canActivate: [OnlyLoggedUsersGuard]
    },

    // Full screen views with layout

    // Views with customer layout
    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/customer-layout/customer-layout.component'
            ).then(m => m.CustomerLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'home',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/invoice',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/bookings',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/customer',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/todo',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/providers',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/employees',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            },
            {
                path: 'home/:org/:customerId/customerdoc',
                loadComponent: () =>
                    import('./views/home.component').then(m => m.HomeComponent)
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'customers',
                loadComponent: () =>
                    import(
                        './views/customers/customers-view/customers-view.component'
                    ).then(m => m.CustomersViewComponent),
                data: { reuse: true }
            },
            {
                path: 'providerDetail',
                loadComponent: () =>
                    import(
                        './views/provider-detail/provider-detail.component'
                    ).then(m => m.ProviderDetailComponent),
                data: { reuse: true }
            },
            {
                path: 'bookings',
                loadComponent: () =>
                    import(
                        './views/bookings-list/provider-bookings.component'
                    ).then(m => m.ProviderBookingsComponent)
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'providerDetail',
                loadComponent: () =>
                    import(
                        './views/provider-detail/provider-detail.component'
                    ).then(m => m.ProviderDetailComponent),
                data: { reuse: true }
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'todo',
                loadComponent: () =>
                    import('./views/todo/todo-list/todo-list.component').then(
                        m => m.TodoListComponent
                    ),
                data: { reuse: true }
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'administration',
                loadComponent: () =>
                    import('./views/admin-actions/admin-actions.component').then(
                        m => m.AdminActionsComponent
                    ),
                data: { reuse: true }
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'employees',
                loadComponent: () =>
                    import(
                        './views/employees/employees-list/employees-list.component'
                    ).then(m => m.EmployeesListComponent),
                data: { reuse: true }
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'customerdoc',
                loadComponent: () =>
                    import(
                        './views/customers/customerdoc-management/customerdoc-management.component'
                    ).then(m => m.CustomerdocManagementComponent),
                data: { reuse: true }
            }
        ]
    },

    {
        path: '',
        loadComponent: () =>
            import(
                './components/layouts/default-layout/default-layout.component'
            ).then(m => m.DefaultLayoutComponent),
        canActivate: [OnlyLoggedUsersGuard, ValidateSyncGuard],
        children: [
            {
                path: 'articles',
                loadComponent: () =>
                    import('./views/articles/articles.component').then(
                        m => m.ArticlesComponent
                    ),
                data: { reuse: true }
            }
        ]
    },

    {
        path: 'logout',
        loadComponent: () =>
            import('./views/logout/logout.component').then(
                m => m.LogoutComponent
            )
    },

    {
        path: '**',
        redirectTo: '/home'
    }
];
